export const FILTER_NOTES = "ADD_NOTES";
export const FILTER_ATTACHMENT = "ADD_ATTACHMENT";
export const FILTER_LOCATION = "ADD_LOCATION";
export const FILTER_LINK = "FILTER_LINK";
export const FILTER_EMAIL = "FILTER_EMAIL";
export const FILTER_URL_NOTE = "FILTER_URL_NOTE";
export const FILTER_CLEAR = "FILTER_CLEAR";
